import { Edit02Icon, Trash01Icon } from '@/components/ui/icons'
import type { SubgeoLegendItem } from '@/features/subgeo/hooks/use-subgeo-colors'
import { useTranslation } from '@/translations/i18n'

interface SubgeoListItemProps {
	item: SubgeoLegendItem
	onEdit: () => void
	onDelete: () => void
}

export const SubgeoListItem = ({
	item,
	onEdit,
	onDelete
}: SubgeoListItemProps) => {
	const { t } = useTranslation()

	return (
		<div className='flex cursor-default items-center gap-2 rounded-lg p-1.5 transition-colors hover:bg-neutral-50 [&:hover_.show-on-hover]:opacity-100 [&_.show-on-hover]:opacity-0 [&_.show-on-hover]:transition-opacity'>
			<div
				className='max-h-[54px] w-1.5 self-stretch rounded'
				style={{ backgroundColor: item.color }}
			/>
			<div className='flex w-full flex-col justify-between font-medium text-neutral-900 text-xs'>
				<span className='line-clamp-2 max-w-[260px] overflow-hidden text-ellipsis whitespace-break-spaces'>
					{item.name}
				</span>
				<div className='font-normal text-[11px] text-neutral-500'>
					{t('subgeo:neighborhood_count', {
						count: item.neighborhoodCount
					})}
				</div>
			</div>
			<div className='show-on-hover flex gap-1'>
				<button
					className='flex cursor-pointer items-center justify-center rounded border-none bg-transparent p-1 text-neutral-600 transition-all hover:bg-neutral-100 hover:text-neutral-900 disabled:cursor-not-allowed disabled:opacity-50'
					onClick={onEdit}
					title={t('subgeo:edit_subgeo')}
					type='button'
				>
					<Edit02Icon size={16} />
				</button>
				<button
					className='flex cursor-pointer items-center justify-center rounded border-none bg-transparent p-1 text-danger-600 transition-all hover:bg-danger-50 hover:text-danger-700 disabled:cursor-not-allowed disabled:opacity-50'
					onClick={onDelete}
					title={t('subgeo:delete_subgeo')}
					type='button'
				>
					<Trash01Icon size={16} />
				</button>
			</div>
		</div>
	)
}
